import { initializeApp } from "firebase/app";

const firebaseConfig =
  import.meta.env.PROD && !import.meta.env.VITE_STAGING
    ? {
        apiKey: "AIzaSyA4uqxa9vOOMY7B1RcLWxxots4Idye9lnE",
        authDomain: "byrdhouseprod.firebaseapp.com",
        projectId: "byrdhouseprod",
        storageBucket: "byrdhouseprod.appspot.com",
        messagingSenderId: "359239151138",
        appId: "1:359239151138:web:197225f406b5252a65247b",
        measurementId: "G-54QBH4H6C0",
      }
    : {
        apiKey: "AIzaSyBYoQyTHM4wek-RX61dDe-ZV1XftMRwRhM",
        authDomain: "byrdhousedev.firebaseapp.com",
        projectId: "byrdhousedev",
        storageBucket: "byrdhousedev.appspot.com",
        messagingSenderId: "375567459847",
        appId: "1:375567459847:web:bf0a659d9639b124376ca2",
        measurementId: "G-9JGCCD7W96",
      };

export function initializeFirebaseApp() {
  if (import.meta.env.VITE_STUB) {
    console.debug("[stub] Skipping Firebase initialization");
    return;
  }
  initializeApp(firebaseConfig);
}
